import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { LoadingButton } from '@mui/lab'

import { useReplyNetworkJoinRequestMutation } from '@/core/services/network'

import { getApiErrorMessage } from '@/utils/errors'

type CancelJoinRequestButtonProps = {
  applicant: string
  networkId: string
}

export default function CancelJoinRequestButton(props: CancelJoinRequestButtonProps) {
  const { applicant, networkId } = props

  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [cancelJoinRequest, { isLoading: isCanceling }] = useReplyNetworkJoinRequestMutation()

  return (
    <LoadingButton
      loading={isCanceling}
      onClick={async () => {
        try {
          await cancelJoinRequest({ networkId, action: 'cancel', applicant })
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.network.cancelJoin.error')), { variant: 'error' })
        }
      }}
      variant="neutral"
    >
      {t('page.network.cancelJoinRequestButton.label')}
    </LoadingButton>
  )
}
